
//Libraries
import { defineComponent, ref } from "vue";

//Store
import { useStore } from "../../../store/index";

//Types
import { ModalMutationOptions } from "../../types/enum/store-enum";

//Components
import LoadingBar from "../LoadingBar.vue";

export default defineComponent({
  name: "GameAccess",
  components: {
    LoadingBar,
  },
  setup() {
    //Data
    const store = useStore();

    const isLoading = ref<boolean>(false);

    const loadingTitle = ref<string>("");

    //Methods
    const create = () => {
      isLoading.value = true;
      loadingTitle.value = "Verificando";

      setTimeout(() => {
        loadingTitle.value = "Redirigiendo";

        setTimeout(() => {
          store.commit(ModalMutationOptions.closeModal);
        }, 1000);
      }, 1000);
    };

    return {
      //Data
      isLoading,
      loadingTitle,
      //Methods
      create,
    };
  },
});
